import { Component, Input } from '@angular/core';
import { ContainerSize } from '@freelancer/ui/container';

@Component({
  selector: 'app-bar',
  template: `
    <fl-container [size]="containerSize" [mobilePadding]="true">
      <nav class="BarContainer">
        <a
          class="BarContainer-title"
          *ngIf="appBarTitle"
          flTrackingLabel="TitleLink"
          [routerLink]="link"
        >
          {{ appBarTitle }}
        </a>
        <fl-scrollable-content
          class="BarContainer-scrollbar"
          [hideHorizontalScroll]="true"
        >
          <div class="BarContainer-items" #items>
            <ng-content select="app-bar-item"></ng-content>
          </div>
        </fl-scrollable-content>
      </nav>
    </fl-container>
  `,
  styleUrls: ['./bar.component.scss'],
})
export class BarComponent {
  @Input() appBarTitle: string;
  @Input() link: string;

  @Input() containerSize: ContainerSize = ContainerSize.DESKTOP_LARGE;
}
